import { styled } from "@linaria/react"

import { LineContentComponent } from "@/components/Diff/DiffLineContent.tsx"
import { LineGutterComponent } from "@/components/Diff/DiffLineGutter.tsx"
import { Horizontal } from "@/components/Flex.ts"
import { isNumber } from "@/lib/std.ts"

import type { DiffTheme } from "@/components/Diff/diffColors.ts"
import type { InlineDiffLine } from "@/lib/client/generated/TypeDefinitions.ts"
import type { Property } from "csstype"
import type { IObservableValue } from "mobx"


export const DiffLineComponent = ({ data, theme, gutterWidth }: {
  data: InlineDiffLine
  theme: DiffTheme
  gutterWidth: IObservableValue<Property.Width>
}) => {
  const oldLineNum = isNumber(data.oldLineNum) ? data.oldLineNum + 1 : null
  const newLineNum = isNumber(data.newLineNum) ? data.newLineNum + 1 : null

  return (
    <Container>
      <LineGutterComponent
        type={data.type}
        theme={theme.gutter}
        width={gutterWidth}
        oldLineNum={oldLineNum}
        newLineNum={newLineNum}
      />

      <LineContentComponent
        data={data}
        lineTheme={theme.line}
        syntaxTheme={theme.syntax}
      />
    </Container>
  )
}

const Container = styled(Horizontal)`
  min-width: 100%;

  line-height: var(--base-line-height);
`